import { ListFilter } from './baseFilters.js';
export class FilterAllOf extends ListFilter {
    constructor(name, values = []) {
        super('allOf', name, values);
    }
}
export class FilterAnyOf extends ListFilter {
    // eslint-disable-next-line no-use-before-define
    constructor(name, values = []) {
        super('anyOf', name, values);
    }
}
